import React from 'react';
import { Helmet } from 'react-helmet-async';

const Orders = () => {
  return (
    <>
      <Helmet>
        <title>Meus Pedidos - Cerveja Delivery</title>
      </Helmet>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <h2 className="text-xl font-bold text-dark-900 mb-4">Meus Pedidos</h2>
        <div className="text-center py-12 text-dark-500">
          <p>Você ainda não possui pedidos.</p>
        </div>
      </div>
    </>
  );
};

export default Orders;